import React, { useContext, useState } from "react";
import SideBarStyles from "../../Styles/ChannelViewer/SideBar.module.css";
import Input from "../../Common/Input.component/Input";
import DisplayChannel from "./DisplayChannel";
import Header from "./Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { ContextForClient } from "../../Context_file/ClientContext";
import { fetchRequest } from "../../helper/CustomFetch";
import { infoToastify } from "../../Common/react_toastify/toastify";

const SideBar = () => {
  const { container, wrapper, searchIcon } = SideBarStyles;
  const [{ resizeFlag, channels }, dispatch] = useContext(ContextForClient);
  const [search, setsearch] = useState("");
  const fieldBgColore = "#333";

  const handleSearchChannel = async ({ target }) => {
    setsearch(target.value);

    const storage = "channels";
    let filterName =
      channels &&
      channels.filter(({ name }) =>
        name.toLowerCase().includes(target.value.toLocaleLowerCase())
      );
    target.value === ""
      ? await fetchRequest({ storage, url: "allchannel", dispatch })
      : filterName.length > 0
      ? await dispatch({ type: "FETCH_CHANNEL", payload: filterName })
      : infoToastify(
          `${target.value} channel doesn't exist on the table. Click on the search icon to search from the database`
        );
  };

  const handleFetchChannelFromServer = async () => {
    const url = `querychannel?channel=${search.toLocaleLowerCase()}`,
      storage = "channels";
    await fetchRequest({ storage, url, dispatch });
    setsearch("");
  };

  return (
    <div>
      <aside className={container}>
        <Header />

        {resizeFlag && (
          <div className={`d-flex container ${wrapper}`}>
            <FontAwesomeIcon
              icon={faSearch}
              className={searchIcon}
              color={!fieldBgColore === "#333" ? "#000" : "#000"}
              onClick={() => handleFetchChannelFromServer()}
              cursor="pointer"
              title="Search from database"
            />
            <Input
              type="text"
              name="search"
              value={search}
              placeholder="search"
              backgroundColor={fieldBgColore}
              border="none"
              className="form-control-lg mb-2 w-100 mt-4"
              onInput={(ref) => handleSearchChannel(ref)}
              autoComplete="off"
              color="#fff"
            />

            <DisplayChannel />
          </div>
        )}
      </aside>
    </div>
  );
};

export default SideBar;
